// Fix map sizing when panel becomes visible
window.addEventListener('load', () => {
    const mapPanels = document.querySelectorAll('.map-content-panel');

    for (const mapPanel of mapPanels) {
        // Dispatch resize event when panel is observed (for fade-in animations)
        const observer = new MutationObserver(function(mutationsList) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (mapPanel.classList.contains('intersect-observed')) {
                        window.dispatchEvent(new Event('resize'));
                    }
                }
            }
        });
        observer.observe(mapPanel, { attributes: true });

        // Also trigger resize immediately and after short delay
        setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
        setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
    }
});